import React from 'react'
import makeStyles from '@mui/styles/makeStyles'
import clsx from 'clsx'
import { Link, useLocation } from 'react-router-dom'
import PrimaryHeaderMenu from './PrimaryHeaderMenu'

import styles from './styles/PrimaryHeaderStyles'
import { useAppSelector } from '../../../store'
import UserMenu from './userMenu'
import { Logo, Logotype } from '../../../../assets/icons'

// @ts-expect-error TS(2345) FIXME: Argument of type '(theme: any) => { PrimaryHeader:... Remove this comment to see the full error message
const useStyles = makeStyles(styles)

const PrimaryHeader = () => {
    const classes = useStyles()
    const location = useLocation()
    const hasTransmission = useAppSelector((state) => state.transmission.transSelected)
    const meetingsStore = useAppSelector((state) => state.meetings)
    const { current: currentConsultation } = meetingsStore

    const eventsDisableClassname = currentConsultation || hasTransmission ? classes.PrimaryHeaderLinkDisable : ''

    const noFade = ![
        '/account',
        '/cgu',
        '/consultations',
        '/dmp',
        '/features',
        '/legals',
        '/summary',
        '/transmission',
    ].includes(location.pathname)

    if (['/consultation', '/transmission'].includes(location.pathname)) return null

    return (
        <div className={clsx(classes.PrimaryHeader, noFade && classes.PrimaryHeaderNoFade)}>
            <Link className={clsx(classes.PrimaryHeaderLink, eventsDisableClassname)} to="/consultations">
                <div className={classes.PrimaryHeaderLogo}>
                    <Logo className={classes.PrimaryHeaderLogoPrimary} />
                    <div className={classes.PrimaryHeaderLogoLogotypeContainer}>
                        <Logotype className={classes.PrimaryHeaderLogoLogotype} />
                    </div>
                </div>
            </Link>
            <PrimaryHeaderMenu />
            <UserMenu />
        </div>
    )
}

export default PrimaryHeader
